import type { DashboardScoreDiagnosticTaskEntity } from '@/core/infrastructure/schemas/dashboard/DashboardScoreDiagnosticTaskSchema'
import { DashboardScoreDiagnosticTaskSchema } from '@/core/infrastructure/schemas/dashboard/DashboardScoreDiagnosticTaskSchema'
import { EvaluationRange } from '@/core/domain/resources/enums/EvaluationRange'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

export class DashboardScoreDiagnosticTask {
  readonly taskId: number
  readonly taskTitle: string
  readonly taskOrder: number
  readonly learningModuleId: number
  readonly learningModuleTitle: string
  readonly learningModuleOrder: number
  readonly diagScorePercentRounded: number | null
  readonly diagEvalRangeName: EvaluationRange.Values | null
  readonly diagEndScorePercentRounded: number | null
  readonly diagEndEvalRangeName: EvaluationRange.Values | null

  constructor(task: DashboardScoreDiagnosticTaskEntity) {
    this.taskId = task.taskId
    this.taskTitle = task.taskTitle
    this.taskOrder = task.taskOrder
    this.learningModuleId = task.learningModuleId
    this.learningModuleTitle = task.learningModuleTitle
    this.learningModuleOrder = task.learningModuleOrder
    this.diagScorePercentRounded = task.diagScorePercentRounded
    this.diagEvalRangeName = task.diagEvalRangeName
    this.diagEndScorePercentRounded = task.diagEndScorePercentRounded
    this.diagEndEvalRangeName = task.diagEndEvalRangeName
  }

  /**
   * Crée une instance de DashboardScoreDiagnosticTask à partir de données brutes
   */
  public static create(data: unknown): DashboardScoreDiagnosticTask {
    return EntityValidator.validateAndCreate(
      DashboardScoreDiagnosticTaskSchema,
      data,
      DashboardScoreDiagnosticTask,
      'DashboardScoreDiagnosticTask'
    )
  }
}
